export default "__VITE_ASSET__BQRsEqb6__"